import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import FileUpload from 'components/DragAndDrop/FileUpload'
import { useDispatch } from 'react-redux'
import { notifyToast } from 'utils/responseUtils'
import { downloadFile } from 'services/file.service'
import { Button } from '@components/ui/button'
import { Link, Upload } from 'lucide-react'
import VisualExamples from './VisualExamples'

const ImageListType = ({
  itemKey,
  value,
  isMobile,
  uploadFile,
  selectImage,
  removeMedia,
  addDraggedImageToModel,
  selectedArgsExample,
  updateArgValues,
  fileInputRef,
}) => {
  const { t } = useTranslation('common')
  const dispatch = useDispatch()
  const [pastedUrl, setPastedUrl] = useState('')

  const handlePastedFileUpload = async (pastedUrl, isSingleFile) => {
    if (pastedUrl) {
      const file = await downloadFile(pastedUrl)
      uploadFile([file], itemKey, isSingleFile)
    } else {
      dispatch(notifyToast('error', 'Please provide a valide URL'))
    }
  }

  return (
    <div>
      <div className={`flex ${value?.length > 1 ? 'flex-col gap-3' : ''}`}>
        <div className="custom-scrollbar-horizontal gap-2 flex overflow-auto">
          {typeof value === 'string' &&
            value?.split(',').map(
              (item, i) =>
                item && (
                  <div
                    key={`img-${itemKey}-${i}`}
                    className="example-img relative w-[115px] md:w-[400px] h-[155px] md:h-[400px] flex-shrink-0 rounded-lg overflow-hidden"
                  >
                    <div
                      className="absolute -top-2 -right-2 cursor-pointer w-7 h-7 bg-white rounded-full shadow-sm flex items-center justify-center z-10 hover:bg-gray-100 transition-colors duration-200"
                      onClick={() => removeMedia(itemKey, i)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </div>
                    <img src={item} alt="image" className="w-full h-full object-cover object-top" />
                  </div>
                )
            )}
        </div>
        <FileUpload
          value={value}
          isMobile={isMobile}
          itemKey={itemKey}
          uploadFile={uploadFile}
          filesToAccept={'image/*, video/*'}
          isSingleFile={false}
          onDropExtraAction={addDraggedImageToModel}
          fileInputRef={fileInputRef}
        />
      </div>
      <div className="flex items-center relative bg-white border border-gray-200 rounded-lg overflow-hidden mb-3 h-12">
        <div className="flex items-center px-3 text-gray-400">
          <Link className="w-4 h-4" />
        </div>
        <input
          placeholder="Paste URL"
          type="text"
          onChange={(e) => setPastedUrl(e.target.value)}
          onPaste={(e) => setPastedUrl(e.target.value)}
          value={pastedUrl}
          className="w-full py-3 px-1 placeholder:text-sm focus:outline-none h-full"
        />
        <Button
          className="px-3 py-2 text-xs rounded-l-none h-full"
          onClick={() => handlePastedFileUpload(pastedUrl, false)}
        >
          Upload
        </Button>
      </div>

      <Button className="w-full py-3 h-12" variant="outline" onClick={() => selectImage(itemKey)}>
        <Upload className="w-4 h-4 mr-2" /> {t('common.library')}
      </Button>

      {typeof value === 'string' && value?.split(',')?.length > 1 && (
        <Button
          variant="outline"
          className="mt-3 text-xs h-8"
          onClick={() => {
            removeMedia(itemKey, null)
          }}
        >
          {t('common.remove-all')}
        </Button>
      )}

      {selectedArgsExample?.length > 0 && (
        <div className="mt-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="h-px bg-gray-200 flex-grow"></div>
            <span className="text-xs text-gray-500 font-medium">{t('model.try-example')}</span>
            <div className="h-px bg-gray-200 flex-grow"></div>
          </div>
          <VisualExamples
            updateArgValues={updateArgValues}
            itemKey={itemKey}
            options={selectedArgsExample}
            selectedOption={value}
            labelKey={'arg_value'}
            imageKey={'preview_media'}
          />
        </div>
      )}
    </div>
  )
}

export default ImageListType
